import { render, staticRenderFns } from "./AppRadioLabel.vue?vue&type=template&id=89515d2a&scoped=true"
import script from "./AppRadioLabel.vue?vue&type=script&lang=js"
export * from "./AppRadioLabel.vue?vue&type=script&lang=js"
import style0 from "./AppRadioLabel.vue?vue&type=style&index=0&id=89515d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89515d2a",
  null
  
)

export default component.exports